export type InputSelectProps = {
    allowInput?: boolean
    autoComplete?: string
    className?: string
    customFilterMatching?: boolean // To use this, you should also set data on InputSelectOption
    disabled?: boolean
    emptyMessage?: string
    hasError?: boolean
    hideSelectedOptions?: boolean
    id: string
    hideLabel?: boolean
    label: string
    mode?: InputSelectMode
    onChange: any
    options?: InputSelectOption[]
    performanceMode?: boolean
    placeholder?: string
    theme?: InputSelectTheme
    value?: InputSelectOption | InputSelectOption[]
    required?: boolean
    clearable?: boolean
    customText?: string
}

export enum InputSelectMode {
    Single = 'single',
    Multiple = 'multiple',
}

export enum InputSelectTheme {
    Widget = 'widget',
    Default = 'default',
}

export type InputSelectOption = {
    value: string
    label: any
    data?: string // To use this, you should also set customFilterMatching to true
}
